export interface LoaderProps {
  visible?: boolean;
  label?: string;
  className?: string;
}

/**
 * KERN Loader Component
 *
 * Usage:
 * <Loader visible />
 * <Loader visible label="Daten werden geladen..." />
 */
export function Loader({ visible = true, label = 'Wird geladen...', className = '' }: LoaderProps) {
  if (!visible) return null;

  const classes = ['kern-loader', 'kern-loader--visible', className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="status">
      <span className="kern-sr-only">{label}</span>
    </div>
  );
}

export default Loader;
